import { z } from "zod";

export const getCrewSchema = z.object({
	planId: z.uuid(),
	crewId: z.uuid(),
});
